/**
 * Student Information assignment metadata — option lists for profile UI.
 *
 * - grade_level_options: string[] — allowed grade values (Apps Manager when grade_level is enabled)
 * - status_options: string[] — allowed status values (Apps Manager when status is enabled)
 * - ended_statuses: string[] (optional) — which status values trigger exit-date prompt; defaults to Withdrawn, Exited, Completed
 */

export const DEFAULT_STUDENT_STATUS_OPTIONS = ['Active', 'Withdrawn', 'Exited', 'Completed'];

export const DEFAULT_ENDED_STUDENT_STATUSES = ['Withdrawn', 'Exited', 'Completed'];

export function parseCommaSeparatedOptions(text) {
  return String(text ?? '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

export function getGradeLevelOptions(metadata) {
  const raw = metadata?.grade_level_options;
  if (!Array.isArray(raw)) return [];
  return raw.map((v) => String(v).trim()).filter(Boolean);
}

export function getStudentStatusOptions(metadata) {
  const raw = metadata?.status_options;
  if (Array.isArray(raw) && raw.length) {
    return raw.map((v) => String(v).trim()).filter(Boolean);
  }
  return [...DEFAULT_STUDENT_STATUS_OPTIONS];
}

export function getEndedStudentStatuses(metadata, statusOptions) {
  const opts = statusOptions ?? getStudentStatusOptions(metadata);
  const configured = metadata?.ended_statuses;
  if (Array.isArray(configured) && configured.length) {
    return configured.map((v) => String(v).trim()).filter((s) => opts.includes(s));
  }
  return DEFAULT_ENDED_STUDENT_STATUSES.filter((s) => opts.includes(s));
}

export function statusBadgeTone(status) {
  const s = String(status ?? '').trim();
  if (!s) return 'neutral';
  if (s === 'Active') return 'success';
  if (s === 'Completed') return 'info';
  if (DEFAULT_ENDED_STUDENT_STATUSES.includes(s)) return 'warning';
  return 'neutral';
}
